import { flattenObject } from "./flatten-object";
import { merge } from "./merge";
import type { FormConfig, Component } from "@/types/FormConfig";

export type ComponentTranslations = {
  [componentName: string]: string | ComponentTranslations;
};

function hasTranslations(component: Component): boolean {
  if (!component.i18n) return false;
  if (Object.keys(component.i18n).length === 0) return false;
  return true;
}

export function generateTranslations(
  defaultTranslations: ComponentTranslations,
  translations = {},
): Record<string, string> {
  const mergedTranslations = merge(defaultTranslations, translations);

  return flattenObject(mergedTranslations);
}

export function getComponentsTranslations(
  components?: FormConfig["components"],
): ComponentTranslations {
  if (!Array.isArray(components)) return {};

  return components
    .filter((component) => hasTranslations(component))
    .map((component) => ({
      [component.name]: component.i18n,
    }))
    .reduce((acc, i18n) => ({ ...acc, ...i18n }), {});
}
